// extracted by mini-css-extract-plugin
export default {"infoText":"piWwZ","offerLink":"NudD6"};